import {
    FETCH_CREATE_PAYMENT_START,
    FETCH_CREATE_PAYMENT_SUCCESS,
    FETCH_CREATE_PAYMENT_FAILURE,
    FETCH_SEND_SMS_PAGE, FETCH_CHECK_SMS_PAGE, FETCH_PAYMENT_BY_TOKEN_PAGE
} from "../actions";

const updatePayment = (state, action) => {
    const initialState = {
        data: null,
        loading: false,
        error: null,
    }
    if (state === undefined) {
        return initialState;
    }
    switch (action.type) {
        case FETCH_SEND_SMS_PAGE:
        case FETCH_CHECK_SMS_PAGE:
        case FETCH_PAYMENT_BY_TOKEN_PAGE:
            return initialState
        case FETCH_CREATE_PAYMENT_START:
            return {
                data: null,
                loading: true,
                error: null,
            }
        case FETCH_CREATE_PAYMENT_SUCCESS:
            return {
                data: action.payload,
                loading: false,
                error: null,
            }
        case FETCH_CREATE_PAYMENT_FAILURE:
            return {
                ...state.payment,
                loading: false,
                error: action.payload,
            }
        default:
            return state.payment
    }
}
export default updatePayment;